import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "./../../../../../services/mainApi.service";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { IMarComAutomationCategories } from "../../../../../models/mar-com-automation-categories";
import { Categories } from "./CategoriesForm/Categories";

const CATEGORY_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationCategory/";
const categoryService = new MainApi<IMarComAutomationCategories>(
  CATEGORY_ROUTE,
);

const translationPath = "page.4uMarCom.automationRules.marcom_categories.";

export const CategoriesPage = memo(() => {
  const [categoryForm, setCategoryForm] = useState(false);

  const { id } = useParams();

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const columns: GridColDef<IMarComAutomationCategories>[] = [
    {
      field: "listCategory",
      headerName: t(translationPath + "list_category") || "List Category",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.row.listCategory.name}
            tooltip={params.row.listCategory.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setCategoryForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IMarComAutomationCategories>,
  ) => {
    if (!params.row) return;
    setCategoryForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setCategoryForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      MarComAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {categoryForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Categories
            id={selectedId}
            marComAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!categoryForm && (
        <Box height={600}>
          <Table<IMarComAutomationCategories>
            showDefaultMacroFilters={false}
            service={categoryService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Search for a category"
            }
            addButtonLabel={
              t(translationPath + "add_category") || "Add Category"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
